import customfn from "@/_functions.js";

$(function () {

    var modal_id = '.create-user-flow';

    // Create user
    $(document).on('click', '#start-create-user', function(ev){
        ev.preventDefault();
        var url = '/user/createnewuser';
        customfn.getModal(url, $(this));
    });

    // If the next button is clicked, get the form fields and post tis with the step
    $(document).on('click', modal_id + ' button.btn.next-step', function(ev){
        ev.preventDefault();
        // get the step from the button
        var step = $(this).data('step');
        var formFields = $(this).closest('.modal').find('form').serialize();
        var url = $(this).attr('href');
        customfn.postModal(url, formFields);
    });

    $(document).on('click', modal_id + ' .add_new_role', function(ev){
        ev.preventDefault();
        var url = '/user/create/role';
        customfn.getModal(url);
    });

    $(document).on('click', modal_id + ' .edit-role', function(ev){
        ev.preventDefault();
        var roleId = $(this).data('roleid');
        var url = $(this).attr('href');
        customfn.getModal(url);
    });

    $(document).on('click', modal_id + ' .delete-role', function(ev){
        ev.preventDefault();
        var roleId = $(this).data('roleid');
        var url = $(this).attr('href');
        customfn.getModal(url);
    });

    // If the next button is clicked, get the form fields and post tis with the step
    $(document).on('click', modal_id + ' button.btn.previous-step', function(ev){
        ev.preventDefault();
        // get the step from the button
        var step = $(this).data('step');
        var url = '/user/create/'+step;
        customfn.getModal(url);
    });

    // If the next button is clicked, get the form fields and post tis with the step
    $(document).on('click', modal_id + ' button.btn.save-user', function(ev){
        ev.preventDefault();
        var url = $(this).attr('href');
        var formFields = $(this).closest('.modal').find('form').serialize();
        customfn.postModal(url, formFields);
    });

    // Assign a role to a user
    $(document).on('click','a.assign-role-user', function(ev){
        ev.preventDefault();
        var userId = $(this).data('user');
        var url = '/user/' + userId + '/assignrole';
        customfn.getModal(url);
    });

    // Open the last page of the
    $(document).on('click', 'a.manage-roles-user', function(ev){
        ev.preventDefault();
        var userId = $(this).data('user');
        var url = '/user/' + userId + '/assignrole/overview';
        customfn.getModal(url, $(this));
    });

    $(document).on('click', 'a.company-manage-roles-user', function(ev){
        ev.preventDefault();

        var url = $(this).attr('href');
        customfn.getModal(url, $(this));
    });

    // Clear all errors
    $(document).on('keydown', modal_id + ' form input', function(){
        $(this).parent().removeClass('is-invalid');
        $(this).next('p.invalid-feedback').hide();
    });

    var typingTimer;
    var doneTypingInterval = 750;

    $(document).on('keyup', modal_id + ' form #email', function(){
        clearTimeout(typingTimer);
        typingTimer = setTimeout(customfn.validateEmail, doneTypingInterval);
    })

    //on keydown, clear the countdown
    $(document).on('keydown', modal_id + ' form #email', function(){
        clearTimeout(typingTimer);
        $(this).parent().removeClass('is-invalid');
        $(this).next().hide();
        $(this).next().next().hide();

        // Set the email field to validated
        $(this).data('validated', 'false');
    });

});
